"use strict"

import ProInfoDialogTemplate from "./pro-info-dialog.html"
import BreadcrumbService from "../../services/breadcrumb-service/breadcrumb.service"
import StaticContentService from "../../services/static/static-content.service"
import LogRocketService from "../../services/log-rocket/log-rocket.service"

export default class ProInfoDialogController {
  /**
   * @ngInject
   * @param {BreadcrumbService} BreadcrumbService
   * @param {StaticContentService} StaticContentService
   * @param {LogRocketService} LogRocketService
   */
  constructor(
    $mdDialog,
    BreadcrumbService,
    StaticContentService,
    LogRocketService,
    source,
  ) {
    this.$mdDialog = $mdDialog

    /** @type {BreadcrumbService} */
    this._breadcrumbService = BreadcrumbService
    /** @type {StaticContentService} */
    this._staticContentService = StaticContentService
    /** @type {LogRocketService} */
    this._logRocketService = LogRocketService

    this._loading = false
    this._source = source
  }

  /**
   * @return {boolean}
   */
  get loading() {
    return this._loading
  }

  goToTeacherPage() {
    this.$mdDialog.hide()
    this._breadcrumbService.go("root.account.create-payment")
  }

  goToOrderPage() {
    this.$mdDialog.hide()
    this._staticContentService.goToOrdersPage(
      this._logRocketService.initialized,
    )
  }

  static show($mdDialog, source) {
    return $mdDialog.show({
      controller: ProInfoDialogController,
      template: ProInfoDialogTemplate,
      controllerAs: "ctrl",
      clickOutsideToClose: true,
      locals: {
        source,
      },
    })
  }

  cancel() {
    this.$mdDialog.cancel()
  }
}
